const ExploreIcon = ({ className, style }) => {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 16 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.1836 1.14335C13.6746 0.26168 12.5233 -0.0010556 11.6822 0.572491L0.911384 7.91687C0.154808 8.43276 -0.0761281 9.44468 0.381735 10.2377L0.828927 11.0123C1.28679 11.8053 2.27861 12.1113 3.10367 11.714L14.8495 6.0584C15.7667 5.61673 16.1148 4.48833 15.6058 3.60666L14.1836 1.14335ZM12.5272 1.8118C12.6474 1.72986 12.8119 1.7674 12.8846 1.89335L14.3068 4.35666C14.3795 4.48261 14.3298 4.64381 14.1987 4.70691L12.1827 5.67763L10.6785 3.07238L12.5272 1.8118ZM9.43578 3.91981L10.8274 6.33021L5.40626 8.9405L4.46462 7.30953L9.43578 3.91981ZM3.22183 8.15696L1.75644 9.15617C1.64835 9.22987 1.61536 9.37443 1.68077 9.48772L2.12796 10.2623C2.19337 10.3756 2.33506 10.4193 2.45293 10.3625L4.05097 9.59307L3.22183 8.15696ZM9.47547 10.4628C9.26622 10.157 8.86499 10.0498 8.53112 10.2106L6.72228 11.0815C6.60403 11.1385 6.50279 11.2255 6.42868 11.3338L4.38105 14.3265C4.14715 14.6683 4.23466 15.1351 4.57652 15.369C4.91837 15.6029 5.38511 15.5153 5.61901 15.1735L7.50003 12.4243V15.25C7.50003 15.6642 7.83582 16 8.25003 16C8.66424 16 9.00003 15.6642 9.00003 15.25V12.4243L10.881 15.1735C11.1149 15.5153 11.5817 15.6029 11.9235 15.369C12.2654 15.1351 12.3529 14.6683 12.119 14.3265L9.47547 10.4628Z"
      />
    </svg>
  )
}

export default ExploreIcon
